// extracted by mini-css-extract-plugin
export default {"row":"MunicipalitySchoolsAttendanceRow_row__lgoqY","schoolName":"MunicipalitySchoolsAttendanceRow_schoolName__rj6td","chart":"MunicipalitySchoolsAttendanceRow_chart__PPAib"};